function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function getRandomItemFromArray(items) {
  const randomIndex = Math.floor(Math.random() * items.length);
  return items[randomIndex];
}

function uncapitalizeFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export {
  getRandomInt,
  getRandomItemFromArray,
  uncapitalizeFirstLetter,
};
